export function arrayGroupByKey(xs, key) {
    const groupList = [];
    const group = xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});

    Object.keys(group).map(k=>{
        let obj = {};
        obj[key] = k;
        obj['dataList'] = group[k];

        groupList.push(obj);
    });

    return groupList;
};
